import {Component, Input, OnInit} from '@angular/core';
import {TranslationService} from '../../../../core/services/translation.service';
import {HupSubscription} from '../../../../data/models/subscription.model';
import {ConfigService} from '../../../../core/services/config.service';

@Component({
  selector: 'app-product-variant-period-block',
  templateUrl: './product-variant-period-block.component.html',
  styleUrls: ['./product-variant-period-block.component.css']
})
export class ProductVariantPeriodBlockComponent implements OnInit {

  @Input() subscription: HupSubscription;
  today: Date = new Date();
  showProductDescription: boolean = true;
  showVariantDescription: boolean = true;
  showOrderNo: boolean = false;

  constructor(
    public translationService: TranslationService,
    private configService: ConfigService
  ) {
  }

  ngOnInit(): void {
    let tmp = this.configService.getConfig('subscription.showProductDescription')?.value?.toLowerCase();
    if (!!tmp) {
      this.showProductDescription = tmp == '1' || tmp == 'true';
    }

    tmp = this.configService.getConfig('subscription.showOrderNo')?.value?.toLowerCase();
    if (!!tmp) {
      this.showOrderNo = tmp == '1' || tmp == 'true';
    }

    tmp = this.configService.getConfig('subscription.showVariantDescription')?.value?.toLowerCase();
    if (!!tmp) {
      this.showVariantDescription = tmp == '1' || tmp == 'true';
    }
  }


}
